import { type ReactElement, type ReactNode } from "react";
import { Tooltip as BeUiTooltip } from "../motion/tooltip";

interface TooltipProps {
  content: ReactNode;
  children: ReactElement;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
}

export function Tooltip({
  content,
  children,
  side = "top",
  className,
}: TooltipProps) {
  return (
    <BeUiTooltip
      content={content}
      side={side}
      className={className}
      wrapperClassName="max-w-full"
    >
      {children}
    </BeUiTooltip>
  );
}
